import DOMAIN from 'constants/domains'
import { LOADER_BAR_TOP } from 'constants/size'
import React from 'react'
import styled from 'styled-components'
import { getDomain } from 'utils/domain'

/**
 * ローディングするバー
 */

const color = {
  [DOMAIN.SAFIC]: 'var(--color-text-for-main-background)',
  [DOMAIN.SJ]: 'var(--color-text)',
}[getDomain()]

const LoaderBar: React.FC = () => {
  return (
    <LoaderArea>
      <Loader />
    </LoaderArea>
  )
}
const LoaderArea = styled.div`
  display: contents;
  position: absolute;
  top: ${LOADER_BAR_TOP};
  right: 0;
  left: 0;
`

const Loader = styled.div`
  position: relative;
  width: 80%;
  height: 6px;
  margin: auto;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 20px;
  &:before {
    position: absolute;
    height: 6px;
    background: ${color};
    border-radius: 20px;
    animation: loading 3s infinite;
    content: '';
    @keyframes loading {
      0% {
        width: 0;
      }
      100% {
        width: 100%;
      }
    }
  }
`

export default LoaderBar
